const styles = {
  container: {
    minWidth: 500,
  },
  formContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "1.2rem",
  },
  division: {
    display: "flex",
    gap: "1rem",
  },
  actionButtons: {
    display: "flex",
    gap: "1rem",
  },
};

export default styles;
